import React, { useEffect, useState } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import PropTypes from 'prop-types';
import { getFilterSets } from '../../store/saved-filters-api';
import SavedFiltersDropdown from './saved-filters-dropdown';
import { SaveFilterSetModal } from '../modals/save-filter-set-modal';
import saveFilterSet from './save-filter-set';
import { emptyArray } from 'ui-components/default-props/empty';

const SavedFilters = ({ path, appliedFilters = emptyArray }) => {
  const [filterSets, setSavedFiltersSets] = useAsyncSafeState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (path) {
      // only fetch if path provided. If no path, don't bother fetching.
      getFilterSets().then((savedFilterSets) => {
        const activeFilters = Object.values(savedFilterSets).filter((f) => f.active);
        const reducedFilterSets = activeFilters.reduce((acc, filter) => {
          return {
            ...acc,
            [filter.orderFilterSetId]: filter,
          };
        }, {});
        setSavedFiltersSets({ ...reducedFilterSets });
      });
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [setSavedFiltersSets]);

  const closeModal = () => setIsModalOpen(false);

  const openModal = () => setIsModalOpen(true);

  const disableSaving = !appliedFilters.length;

  const onSaveFilters = (name) => {
    saveFilterSet(name, appliedFilters).then((savedFilterSet) => {
      setSavedFiltersSets({
        ...filterSets,
        [savedFilterSet.orderFilterSetId]: savedFilterSet,
      });
    });
  };

  return (
    <React.Fragment>
      <SavedFiltersDropdown
        disableSaving={disableSaving}
        filterSets={filterSets} // Only show the dropdown on the orders page.
        openModal={openModal}
        path={path}
      />
      {isModalOpen && <SaveFilterSetModal onClose={closeModal} saveFilters={onSaveFilters} />}
    </React.Fragment>
  );
};

SavedFilters.propTypes = {
  path: PropTypes.string,
  appliedFilters: PropTypes.array,
};

export default SavedFilters;
